<template>
  <div class="first-step">
    <div
      v-for="(itm, index) in items"
      :key="'first-step-item-' + index"
      :style="{
        width: itm.style.width + '%',
        top: itm.style.top + '%',
        left: itm.style.left + '%',
        cursor: itm.style.cursor,
        top: itm.style.top + '%',
        bottom: itm.style.bot + '%',
        left: itm.style.left + '%',
        right: itm.style.right + '%',
        background: itm.style.bcg,
        width: itm.style.width + '%',
        height: itm.style.height + '%',
        opacity: itm.style.opacity,
        color: itm.style.color || mainColor,
        transform: itm.style.transform,
        position: 'absolute',
      }"
    >
      <img
        v-if="itm.type == 'img'"
        :class="itm.style.class"
        :style="{
          width: '100%',
          height: '100%',
          cursor: itm.style.cursor,
          objectPosition: itm.style.objectPosition | 'left bottom',
          animationDelay: (itm.style.delay | 0) / 100 + 's',
        }"
        :src="itm.content"
      />
      <div
        class="box"
        @click="firstStepOff()"
        v-if="itm.type == 'text'"
        :class="itm.style.class + ' ' + itm.style.hover"
        :style="{
          animationDelay: (itm.style.delay | 0) / 100 + 's',
          borderColor: mainColor,
        }"
      >
        <p
          :class="itm.style.class + ' ' + itm.style.hover"
          :style="{
            width: '100%',
            fontSize: itm.style.fontSize + 'rem',
            margin: itm.style.margin || 0,
            fontFamily: itm.style.font || 'Arial',
            animationDelay: (itm.style.delay | 0) / 100 + 's',
          }"
          v-html="itm.content"
        ></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'firs-step',
  components: {},
  props: {
    desc: {
      type: String,
      default: function () {
        return '';
      },
    },
    mainColor: {
      type: String,
      default: function () {
        return '#309de4';
      },
    },
    items: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  mounted() {
    if (this.items.length == 0) {
      this.firstStepOff();
    }
  },
  methods: {
    firstStepOff() {
      this.$emit('firsstepoff');
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
  },
  computed: {
    currentSlide() {
      return this.$store.getters.getCurrentStep;
    },
  },
};
</script>
<style lang="sass">
@import '../../style/base'
.first-step
  top: 0
  left: 0
  position: fixed
  width: 100%
  height: 100%
  background: transparent
  z-index: 1000
  .box
    text-align: center
    width: 100%
    height: 100%
    background: white
    border: calc(1080px * 0.015) solid $MAC_MAIN_COLOR
    border-radius: 1em
    cursor: pointer
    display: flex
    justify-content: center
    align-items: center

  h2
    position: absolute
    top: 50%
    transform: translate(0, -50%)
    width: 100%
    margin: auto
    font-size: 4rem
    font-family: Alber-Bold_2, sans-serif
</style>
